'use es6';

import * as CurrencyCodes from 'self-service-api/constants/CurrencyCodes';
import { createSelector } from 'reselect';

const customerCurrencyCodeSelector = ({
  customerCurrencyCode
}) => customerCurrencyCode;

export const activeCurrencySelector = state => {
  const {
    activeCurrencyCode
  } = state;
  const customerCurrencyCode = customerCurrencyCodeSelector(state);

  if (customerCurrencyCode) {
    return customerCurrencyCode;
  }

  if (!CurrencyCodes[activeCurrencyCode]) return CurrencyCodes.USD;
  return activeCurrencyCode;
};
export const availableCurrenciesSelector = createSelector(customerCurrencyCodeSelector, customerCurrencyCode => {
  if (customerCurrencyCode) return [customerCurrencyCode];
  return Object.values(CurrencyCodes);
});